module.exports = "<div class=\"col-md-12\">\n  <nv-rewards [document]=\"document\"\n              [pointer]=\"'/resources'\"\n              [title]=\"'Ресурсы'\"></nv-rewards>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/app/components/nv-profile-resources/nv-profile-resources.component.html
// module id = ../../../../../src/app/components/nv-profile-resources/nv-profile-resources.component.html
// module chunks = 0